var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
        infobar: false,
        buttons: [
            "close"
        ],
    });
};



// Background image holder
//-----------------------------------------------------------------
mp.backgroundHolder = function() {
    var $element = $(".background-holder");

    if (!$element.length) {
        return;
    }

    $element.each(function(){
        var $img = $(this).find('img');
        var $imageSrc = $img.attr('src');
        $img.remove();
        $(this).css('background-image', 'url('+$imageSrc+')').addClass('show');
    });
};



// Tabs
//-----------------------------------------------------------------
mp.tabs = function() {
    var $element = $(".tabs");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '.tabs [data-toggle]', function(e){
        e.preventDefault();
        
        var $tabID = $(this).data("toggle");

        $(this).parents('.tabs').find("[data-toggle], .tabs__content").removeClass("active");
        
        $(this).parents('.tabs').find(".tabs__nav [data-toggle='"+$tabID+"']").addClass("active");
        $(this).parents('.tabs').find("#"+$tabID).addClass("active");
    })
};



// Accordion
//-----------------------------------------------------------------
mp.accordion = function() {
    var $element = $(".accordion");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '.accordion [data-toggle]', function(e){
        e.preventDefault();
        
        $(this).parents('.accordion__item').toggleClass("active").find('[data-content]').slideToggle();
    })
};



// Toggle
//-----------------------------------------------------------------
mp.toggle = function() {
    var $element = $("[data-toggle]");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '[data-toggle]', function(e){
        e.preventDefault();
        
        $target = $(this).data('toggle');
        $(this).toggleClass('active');
        $('[data-content="'+$target+'"]').toggleClass('active');
    })
};


// Filter Stores
//-----------------------------------------------------------------
mp.filterStores = function() {
    var $element = $('[data-filter="stores"]');

    if (!$element.length) {
        return;
    }

    $(document).on('change', '[data-filter="stores"]', function(e){
        e.preventDefault();

        $filter = $(this).val();

        if ($filter) {
            $('[data-filter-value]').hide();
            $('[data-filter-value="'+$filter+'"]').show();
        } else {
            $('[data-filter-value]').show();
        }
    })
};


// Parallax
//-----------------------------------------------------------------
mp.parallax = function() {
    var $element = $(".parallax");

    if (!$element.length) {
        return;
    }

    var $images = document.querySelectorAll('.parallax');

    new simpleParallax($images, {
        scale: 1.3,
    });
};



// Init Selectric
//-----------------------------------------------------------------
mp.selectric = function() {
    var $trigger = $('.form__select');

    if (!$trigger.length) {
        return;
    }

    $trigger.selectric({
        disableOnMobile: false,
        nativeOnMobile: true,
    });
}

// Responsive video
//-----------------------------------------------------------------
mp.fitVids = function() {
    var $element = $('.wysiwyg');

    if (!$element.length) {
        return;
    }

    $element.fitVids();
}





$(document).ready(function (){
    mp.fancyBox();
    mp.tabs();
    mp.accordion();
    mp.parallax();
    mp.toggle();
    mp.filterStores();
    mp.selectric();
    mp.fitVids();
    //mp.backgroundHolder();
});